export type DetectedInputType = 'id' | 'phone' | 'text';

/**
 * Advisory classification of a raw query. Drives the UI hint and field
 * boosting only — the gateway always searches broadly, so misclassification
 * never excludes a matching document.
 */
export function detectInputType(raw: string): DetectedInputType {
  const q = raw.trim();
  if (!q) return 'text';

  const digits = q.replace(/\D/g, '');
  const nonPhoneChars = q.replace(/[\d\s+()/\-.]/g, '');
  const hasSeparator = /[+()/-]/.test(q) || /\d\s+\d/.test(q);

  // Formatted, digit-dominated string with separators → phone.
  if (digits.length >= 6 && nonPhoneChars.length === 0 && hasSeparator) return 'phone';

  // Pure digits: short = ID, long = phone number.
  if (/^\d+$/.test(q)) return q.length >= 8 ? 'phone' : 'id';

  return 'text';
}
